import React from 'react'
import ReactDOM from 'react-dom'
import { loadableReady } from '@loadable/component'

export default function hydrate(Component, props, domElement) {
  if (Component) {
    loadableReady(() => {
      const renderOrHydrate = domElement.innerHTML.trim().length
        ? 'hydrate'
        : 'render'
      ReactDOM[renderOrHydrate](
        React.createElement(Component, props, null),
        domElement
      )
    })
    // https://github.com/reactql/cli/issues/86
  } else {
    console.error('Hydrate called without Component argument')
  }
}
